import React from "react"

import ConfigureBuild from "./ConfigureBuild"
import ApplicationForm from "./ApplicationForm"

class RequestBuild extends React.Component{
    render(){
        const { projectId, appConfig, isAdmin, getAppConfig } = this.props
        return (
            <>
                {appConfig.length === 0
                    ? <ApplicationForm projectId={projectId} getAppConfig={this.props.getAppConfig}/>
                    : <ConfigureBuild projectId={projectId} appConfig={appConfig} 
                        isAdmin={isAdmin} getAppConfig={getAppConfig}/>
                }
            </>
        )
    }
}

export default RequestBuild